import React, { useMemo } from 'react';
import helpers from '@starflow/app/helpers';

export const LeftPanel = () => {
  const renderedComponents = useMemo(() => {
    return helpers.component.getLeftPanelComponents().map(({ Component }, index) => <Component key={index} />);
  }, []);

  return (
    <aside
      id="left-panels-wrapper"
      className="absolute top-0 left-0 flex flex-col flex-shrink-0 empty:hidden pointer-events-none"
    >
      {renderedComponents}
    </aside>
  );
};
